import React from "react";
import { css } from "@emotion/react";
import consulting from "@src/assets/expert/consulting.png";
import bidAgent from "@src/assets/expert/bidAgent.png";
import findingFace from "@src/assets/expert/findingFace.png";
import writingFace from "@src/assets/expert/writingFace.png";

const UserAgentNotice = () => {
    return (
        <div css={noticeContainerStyle}>
            <div css={TitleStyle}>
                경매대행 (매물컨설팅+매수신청대리) <br />
                <span style={{ fontWeight: "normal", fontSize: "18px" }}>서비스 이렇게 진행돼요!</span>
            </div>
            <div css={ContentContainerStyle}>
                {/* Step1 */}
                <div className="stepBox">
                    <img src={consulting} alt="consulting" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.01</span> 매물컨설팅
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlackSubTitleStyle}>
                            매수신청대리 자격을 갖춘 경매 전문가를 <br />
                            빠르게 찾아, 매물에 대한 컨설팅을 받아요.{" "}
                        </p>
                        <p css={BlackContentStyle}>
                            ✔️ 컨설팅 비용 : 33만원 <br />
                            ✔️ 매칭 1회 실패시, 의뢰인은 컨설팅 비용을 <br />
                            최대 80만원까지 올려 다시 요청할 수 있어요.
                        </p>
                        <div css={dividerStyle} style={{ margin: "8px 0" }} />

                        <div css={FlexColumnStyle} style={{ marginTop: "24px" }}>
                            <div>
                                <p css={BlueTitleStyle}>❶ 의뢰 요청</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    매물의 사건번호, 요청사항을 입력하고
                                    <br /> 전국에 있는 경매대행 전문가에게 즉시 <br />
                                    컨설팅 의뢰를 보내요. <br />
                                    <span style={{ fontSize: "13px" }}>(매수신청대리 자격 있는 전문가에게 의뢰)</span>
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❷ 원하는 전문가 선택</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    전문가들은 해당 의뢰에 실시간으로 지원하고, <br />
                                    의뢰인은 지원한 전문가들의 프로필을 확인하거나 <br />
                                    채팅을 하며 자신이 원하는 전문가를 직접 선택해요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❸ 매칭 완료</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    지원한 전문가 중 한 명을 선택하고 ‘매칭확정하기’를 눌러 담당 전문가로 지정하면, 매칭이
                                    완료돼요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❹ 컨설팅 </p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    매칭이 확정된 전문가에게 내가 의뢰한 매물의 권리 분석, 입지 분석 등 매물에 대한 컨설팅을
                                    받아요.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Step2 */}
                <div className="stepBox">
                    <img src={bidAgent} alt="bidAgent" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.02</span> 매수신청대리 (입찰대리)
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlackSubTitleStyle}>
                            컨설팅을 완료하고, 동일한 또는 다른 전문가에게 법원 입찰대리를 맡길 수 있어요.
                        </p>
                        <p css={BlackContentStyle}>
                            ✔️ 서비스 이용료 : 4만 5천원 <br />
                            ✔️ 낙찰 수수료 : 감정가의 1% 별도 직접 지불
                        </p>

                        <div css={dividerStyle} style={{ margin: "8px 0" }} />
                        <p css={GreyContentStyle}>
                            Q. 수수료는 언제 주나요?
                            <br />
                            <span style={{ borderBottom: "2px solid #FF0000", paddingBottom: "2px", lineHeight: "1.8" }}>
                                매각기일 허가 결정이 났을 때
                            </span>{" "}
                            매수신청대리인에게 직접 입금하면 돼요
                            <br />
                            <br />
                            Q. 낙찰을 못 받았을 때는요?
                            <br />
                            <span style={{ borderBottom: "2px solid #FF0000", paddingBottom: "2px", lineHeight: "1.8" }}>
                                수수료가 없으므로 지불하지 않아요 <br />
                            </span>
                            서비스 이용료는 이미 지불했고 (4만 5천원), <br />
                            낙찰을 못 받았으므로 추가 지불할 비용은 없어요.
                            <br /> <br />
                            Q. 미스고는 어떤 역할인가요?
                            <br />
                            미스고는 전문가를 찾아 매칭을 도울 뿐, <br />
                            <span style={{ borderBottom: "2px solid #FF0000", paddingBottom: "2px", lineHeight: "1.8" }}>
                                매수신청대리, 즉 입찰을 대리하는 주체가 아니에요
                            </span>
                            <br />
                            매수신청대리인이 서비스 주체예요.
                        </p>
                    </div>
                    <div css={LightGrayBoxStyle}>
                        <p css={BlackSubTitleStyle}>
                            ✋🏼 매수신청대리는 <br /> 다른 전문가에게 의뢰하고 싶어요!
                        </p>
                        <p css={BlackContentStyle}>
                            가능해요!
                            <br />
                            우선 컨설팅에 대한 후기를 작성하여 완료한 후, <br />
                            다른 매수신청대리인을 찾을 수 있어요.
                            <br />
                            매수신청대리 매칭 이용권을 함께 구매했으니
                            <br /> 추가 결제는 없어요!
                        </p>
                    </div>
                </div>
                {/* Step3 */}
                <div className="stepBox">
                    <img src={findingFace} alt="step3" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.03</span> 매수신청대리 입찰 이후
                    </p>

                    <div css={BlueBoxStyle}>
                        <p css={BlackSubTitleStyle}>
                            매수신청대리인 ↔️ 의뢰인 직접 거래 방식이에요. 입찰 결과에 따라 수수료 유/무가 달라져요!
                        </p>
                        <p css={FlexStyle}>
                            <span css={RedTextBoxStyle} style={{ minWidth: "fit-content" }}>
                                낙찰
                            </span>
                            <p css={GreyContentStyle}>
                                매각허가 결정 이후 감정가 1%의 수수료가 발생해요. 해당 매물에 세입자가 거주하는 경우 명도 컨설팅도
                                제공받을 수 있어요.
                            </p>
                        </p>
                        <p css={FlexStyle}>
                            <span css={BlueTextBoxStyle} style={{ minWidth: "fit-content" }}>
                                불찰
                            </span>
                            <p css={GreyContentStyle}>수수료가 없어요.</p>
                        </p>
                        <p css={FlexStyle}>
                            <span css={BlueTextBoxStyle} style={{ minWidth: "fit-content" }}>
                                유찰
                            </span>
                            <p css={GreyContentStyle}>
                                <span style={{ borderBottom: "2px solid #FF0000", paddingBottom: "2px" }}>
                                    유찰 시 3번까지 매수신청대리 서비스
                                </span>
                                를 제공받을 수 있어요.
                            </p>
                        </p>
                    </div>
                </div>
                {/* Step4 */}
                <div className="stepBox">
                    <img src={writingFace} alt="step4" className="stepIcon" width={50} height={50} />

                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.04</span> 후기 작성
                    </p>
                    <p css={DarkGreyContentStyle} style={{ marginTop: "14px" }}>
                        매칭된 전문가에 대한 후기를 작성해요. <br />
                        제공 받은 컨설팅/매수신청대리 서비스가 어땠는지
                        <br /> 좋은 점, 아쉬운 점을 작성해주세요.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserAgentNotice;

export const noticeContainerStyle = css`
    width: 100%;
    padding: 30px 14px;
`;

export const TitleStyle = css`
    color: #0c002c;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.4;
    text-align: left;
    margin-bottom: 28px;
`;

export const ContentContainerStyle = css`
    padding-left: 30px;
    margin-left: 24px;
    border-left: 2px solid #efefef;

    .stepBox {
        position: relative;
    }

    .stepIcon {
        position: absolute;
        top: -13px;
        left: -56px;
    }
`;

export const BlueBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #eff8ff;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const LightGrayBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const BlueTitleStyle = css`
    color: #2275ee;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
`;

export const BlackTitleStyle = css`
    color: #282828;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.4;
`;

export const BlackSubTitleStyle = css`
    color: #382e51;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 14px;
`;
export const BlackStepStyle = css`
    color: #282828;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 8px;
`;

export const BlackContentStyle = css`
    color: #3c3c3c;
    font-size: 13px;
    line-height: 1.4;
`;

export const GreyContentStyle = css`
    color: #8d8d8d;
    font-size: 13px;
    line-height: 1.4;
`;

export const RedContentStyle = css`
    color: #ff0000;
    font-size: 13px;
    line-height: 1.4;
`;

export const RedTextBoxStyle = css`
    background-color: #ff0000;
    padding: 4px;
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
`;

export const BlueTextBoxStyle = css`
    background-color: #2275ee;
    padding: 4px;
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
`;
export const dividerStyle = css`
    width: 100%;
    height: 1px;
    background-color: #e8e8e8;
    margin-top: 14px;
    margin-bottom: 14px;
`;

export const FlexColumnStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
`;
export const FlexStyle = css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    margin-top: 14px;
`;
export const DarkGreyContentStyle = css`
    color: #505050;
    font-size: 14px;
    line-height: 1.4;
`;
